import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LiveUrlConfig {
  public id = 'Live';
  public url: string = null;
}
